import { type FC, useEffect } from 'react';

import { useNotificationsContext } from '@/contexts/notifications/Notifications.context.ts';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

/**
 * Initializes notifications once the user context is ready. Redirecting
 * uninitialized users is route guard loader business (OCD-309).
 */
export const UserInitializeController: FC = () => {
  const {
    user: { dataReady, initializationDone },
  } = useUserContext();
  const { updateNotifications } = useNotificationsContext();

  useEffect(() => {
    if (dataReady && initializationDone) {
      updateNotifications();
    }
  }, [dataReady, initializationDone, updateNotifications]);

  return null;
};
